import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

import config from '../config/config';
import authHeader from '../config/authHeader';
import { useAuth } from '../contexts/AuthContext';

import { sanitizeText } from '../utils/SanitizeText';
import { formatDate, formatHeure } from '../utils/Format';

import useFetchSites from '../hooks/useFetchSites';
import useFetchDeclarations from '../hooks/useFetchDeclarations';
import useFetchLstDocs from '../hooks/useFetchDocs';
import useFetchDommages from '../hooks/useFetchDommages';

import ListRDV from '../components/Dashboard/ListRDV';
import Map from '../components/Dashboard/Map';
import TrelloBoard from '../components/Dashboard/TrelloBoard';

import Switcher from '../utils/Switcher';

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import pin from '../assets/img/Map/pin-icon.png';
dayjs.locale('fr');

function Dashboard() {
    const { user, hasRole } = useAuth();

    const [showMap, setShowMap] = useState(false);
    const [selectedTab, setSelectedTab] = useState("list");

    const { countSites, site, fetchCountSites, fetchSiteByUUID, loading: loadingS } = useFetchSites();
    const { countDeclarations, fetchCountDeclarations, loading: loadingD } = useFetchDeclarations();
    const { countExpertises, fetchCountExpertises, loading: loadingEx } = useFetchLstDocs();
    const { countDommages, fetchCountDommages, loading: loadingDo } = useFetchDommages();

    const [loadingRDV, setLoadingRDV] = useState(true);
    const [lstRdv, setLstRdv] = useState([]);
    const [displayedRdvCount, setDisplayedRdvCount] = useState(0);

    const [locations, setLocations] = useState([]);
const [visibleRdv, setVisibleRdv] = useState([]);


    useEffect(() => {
        fetchCountSites();
        fetchCountExpertises();
        fetchCountDeclarations();
        fetchCountDommages();
    }, []);

    useEffect(() => {
        setLoadingRDV(true);

        fetch(`${config.apiBaseUrl}/4DACTION/KST_getLstRdv`, {
            method: 'GET',
            headers: authHeader()
        })
            .then((response) => response.json())
            .then((data) => {
                setLstRdv(data);
            })
            .catch((error) => {
                console.error("Erreur lors de la récupération des rendez-vous:", error);
                setLoadingRDV(false);
            });

        setLoadingRDV(false);
    }, []);

    if (lstRdv.length === 0) {
        lstRdv[0] = { Titre: "Aucun rendez-vous à venir" };
    } else {
        lstRdv.forEach((rdv) => {
            const parseDate = (dateStr) => {
                return (dateStr && dateStr !== '0000-00-00') ? new Date(dateStr) : null;
            };

            const dateConvoc = parseDate(rdv.Date_Convoc);
            const dateRdv = parseDate(rdv.Date_Rdv);

            let dateFix = '';

            if (dateConvoc && dateRdv) {
                dateFix = (dateRdv > dateConvoc) ? rdv.Date_Rdv : rdv.Date_Convoc;
            } else if (dateRdv) {
                dateFix = rdv.Date_Rdv;
            } else if (dateConvoc) {
                dateFix = rdv.Date_Convoc;
            }

            rdv.Date_Fix = dateFix;
            rdv.Heure_Fix = formatHeure((rdv.Date_Rdv === '0000-00-00') ? ((rdv.Date_Convoc === '0000-00-00' ? '' : rdv.Heure_Convoc)) : rdv.Heure_Rdv) ? formatHeure((rdv.Date_Rdv === '0000-00-00') ? ((rdv.Date_Convoc === '0000-00-00' ? '' : rdv.Heure_Convoc)) : rdv.Heure_Rdv) : 'Non Renseignée';
            rdv.Titre = sanitizeText(rdv.Titre);
        });
    };

    const customIcon = new L.Icon({
        iconUrl: pin,
        iconSize: [30, 30],
        iconAnchor: [15, 30],
        popupAnchor: [0, -30]
    });
const fetchLocations = async () => {
  const locationPromises = visibleRdv
    .filter(rdv => rdv.UUID_Site_)
    .map(async (rdv) => {
      try {
        const siteData = await fetchSiteByUUID(rdv.UUID_Site_);

        if (!siteData) return null;

        return {
          ...siteData,
          rdvDate: rdv.Date_Fix,
          rdvHeure: rdv.Heure_Fix,
          declarationLibelle: rdv.DeclarationLibelle,
          UUID_Declaration: rdv.UUID_Declaration,
        };
      } catch (error) {
        console.error("Erreur lors de la récupération du site:", error);
        return null;
      }
    });

  const locationResults = await Promise.all(locationPromises);
  setLocations(locationResults.filter(loc => loc));
};

useEffect(() => {
  if (visibleRdv.length > 0) {
    fetchLocations();
  } else {
    setLocations([]);
  }
}, [visibleRdv]);



    // const handleRowDoubleClick = (event) => {
    //     const clickedRowData = event.rowData;
    //     const uuid = clickedRowData.UUID_Declaration;
    //     if (uuid) navigate(`/declarations/${uuid}`);
    // };

    // if (loadingS || loadingD || loadingL || loadingDo) {
    //     return <div className="flex flex-1 justify-center items-center"><Loader /></div>;
    // }

    // console.log(lstRdv);

    return (
        <div class="flex-1 p-5 lg:p-10">
            <div class="gap-6 grid grid-cols-12">
                <div class="gap-6 grid grid-cols-12 col-span-12 xxl:col-span-9">
                    <div class="col-span-12 mt-6 lg:mt-8">
                        <h1 class="mb-10 w-full font-bold text-gray-800 text-4xl text-center">Tableau de Bord</h1>
                        {!hasRole('visiteur') && (
                            <div id="form-count" class="gap-6 grid grid-cols-12 my-5">
                                <Link class="col-span-12 sm:col-span-6 xl:col-span-3 bg-white shadow-lg rounded-lg hover:scale-105 transition duration-300 transform intro-y"
                                    to="/sites">
                                    <div class="p-5">
                                        <div class="flex justify-between">
                                            <div class="text-blue-500 text-center">
                                                <i class="fa-solid fa-city fa-lg"></i>
                                            </div>
                                            <div
                                                class="flex justify-items-center bg-blue-500 px-2 rounded-full h-6 font-semibold text-white text-sm">
                                                {/* <span class="flex items-center">30%</span> */}
                                            </div>
                                        </div>
                                        <div class="flex-1 ml-2 w-full">
                                            <div>
                                                <div class="mt-3 font-bold text-3xl leading-8">{loadingS ? <div class="bg-gray-100 rounded-md w-20 h-8 animate-pulse"></div> : countSites}</div>

                                                <div class="mt-1 text-gray-600 text-base">Sites</div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                                <Link class="col-span-12 sm:col-span-6 xl:col-span-3 bg-white shadow-lg rounded-lg hover:scale-105 transition duration-300 transform intro-y"
                                    to="/declarations">
                                    <div class="p-5">
                                        <div class="flex justify-between">
                                            <div class="text-green-500 text-center">
                                                <i class="fa-solid fa-scroll fa-lg"></i>
                                            </div>
                                            <div
                                                class="flex justify-items-center bg-green-500 px-2 rounded-full h-6 font-semibold text-white text-sm">
                                                {/* <span class="flex items-center">30%</span> */}
                                            </div>
                                        </div>
                                        <div class="flex-1 ml-2 w-full">
                                            <div>
                                                <div class="mt-3 font-bold text-3xl leading-8">{loadingD ? <div class="bg-gray-100 rounded-md w-20 h-8 animate-pulse"></div> : countDeclarations}</div>

                                                <div class="mt-1 text-gray-600 text-base">Déclarations</div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                                <Link class="col-span-12 sm:col-span-6 xl:col-span-3 bg-white shadow-lg rounded-lg hover:scale-105 transition duration-300 transform intro-y"
                                    to="">
                                    <div class="p-5">
                                        <div class="flex justify-between">
                                            <div class="text-yellow-500 text-center">
                                                <i class="fa-solid fa-comments fa-lg"></i>
                                            </div>
                                            <div
                                                class="flex justify-items-center bg-yellow-500 px-2 rounded-full h-6 font-semibold text-white text-sm">
                                                {/* <span class="flex items-center">30%</span> */}
                                            </div>
                                        </div>
                                        <div class="flex-1 ml-2 w-full">
                                            <div>
                                                <div class="mt-3 font-bold text-3xl leading-8">{loadingEx ? <div class="bg-gray-100 rounded-md w-20 h-8 animate-pulse"></div> : countExpertises}</div>

                                                <div class="mt-1 text-gray-600 text-base">{countExpertises == 1 ? "Expertise" : "Expertises"}</div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                                <Link class="col-span-12 sm:col-span-6 xl:col-span-3 bg-white shadow-lg rounded-lg hover:scale-105 transition duration-300 transform intro-y"
                                    to="/dommages">
                                    <div class="p-5">
                                        <div class="flex justify-between">
                                            <div class="text-red-500 text-center">
                                                <i class="fa-solid fa-fire-extinguisher fa-lg"></i>
                                            </div>
                                            <div
                                                class="flex justify-items-center bg-red-500 px-2 rounded-full h-6 font-semibold text-white text-sm">
                                                {/* <span class="flex items-center">30%</span> */}
                                            </div>
                                        </div>
                                        <div class="flex-1 ml-2 w-full">
                                            <div>
                                                <div class="mt-3 font-bold text-3xl leading-8">{loadingDo ? <div class="bg-gray-100 rounded-md w-20 h-8 animate-pulse"></div> : countDommages}</div>

                                                <div class="mt-1 text-gray-600 text-base">{countDommages == 1 ? "Dommage" : "Dommages"}</div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        )}

                        <div className="bg-white p-4 rounded-lg">
                            <div className="flex lg:flex-row flex-col justify-between items-start lg:items-center mx-auto my-4 lg:my-8 px-6 pb-4 border-gray-300 border-b container">
                                <div class="flex items-center">
                                    <h4 className="mr-10 font-bold text-gray-800 text-2xl leading-tight">Rendez-Vous à venir (J+10)</h4>
                                    <div class="flex items-center space-x-2">
                                        <i class="fa-solid fa-list fa-lg"></i>
                                        <Switcher
                                            isChecked={selectedTab === 'map'}
                                            setIsChecked={(val) => setSelectedTab(val ? 'map' : 'list')}
                                        />
                                        <i class="fa-solid fa-map fa-lg"></i>
                                    </div>

                                </div>

                                <div className="mt-2 lg:mt-0">
                                    <li className="flex items-center mt-3 md:mt-0 text-gray-600 text-sm">
                                        <span className="mr-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="icon-tabler icon-tabler-calendar-event icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                <rect x="4" y="5" width="16" height="16" rx="2" />
                                                <line x1="16" y1="3" x2="16" y2="7" />
                                                <line x1="8" y1="3" x2="8" y2="7" />
                                                <line x1="4" y1="11" x2="20" y2="11" />
                                                <rect x="8" y="15" width="2" height="2" />
                                            </svg>

                                        </span>
<span>
  {visibleRdv.length === 1 && visibleRdv[0]?.Titre === "Aucun rendez-vous à venir"
    ? 0
    : visibleRdv.length} Rendez-vous
</span>


                                    </li>
                                </div>
                            </div>
                            <div className="relative w-full overflow-hidden">
                                <div
                                    className="flex h-full transition-transform duration-500 ease-in-out"
                                    style={{
                                        transform: selectedTab === 'list' ? 'translateX(0%)' : 'translateX(-100%)',
                                    }}
                                >
                                    <section className="flex-none w-full min-w-0">
                                        <div className="mx-auto px-6">
                                            <ListRDV lstRdv={lstRdv} loading={loadingRDV} onCountChange={setDisplayedRdvCount}  onVisibleRdvChange={setVisibleRdv} />
                                        </div>
                                    </section>


                                    <section className="flex-none lg:mx-auto mb-4 lg:mb-8 p-6 w-full min-h-[420px] lg:min-h-[600px]">
                                        <Map
                                            key={selectedTab === 'map' ? 'map-visible' : 'map-hidden'}
                                            locations={locations}
                                            customIcon={customIcon}
                                            visible={selectedTab === 'map'}
                                        />
                                    </section>
                                </div>
                            </div>

                        </div>

                        {!hasRole('visiteur') && (
                            <div className="bg-white mt-6 p-4 rounded-lg">
                                <TrelloBoard />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>

    );
}

{/* <div class="flex-1 p-10">
    <div class="gap-6 grid grid-cols-12">
        <div class="gap-6 grid grid-cols-12 col-span-12 xxl:col-span-9">
            <div class="col-span-12">

            </div>
        </div>
    </div>
</div> */}

export default Dashboard;
